import type { FONT_AWESOME_ICONS, IconProps } from 'components/icon';
import type { DefaultTheme } from 'styled-components';
import { FILE_ICON_CONFIG, isFileType } from '../file_gallery/constants';

export const getImageSrcFromBuffer = (buffer: { type: string; data: number[] }): string | undefined => {
  if (!buffer.data.length) return undefined;

  const uint8Array = new Uint8Array(buffer.data);
  const chunkSize = 0x8000;
  let binary = '';
  for (let i = 0; i < uint8Array.length; i += chunkSize) {
    binary += String.fromCharCode(...uint8Array.subarray(i, i + chunkSize));
  }

  return `data:${buffer.type};base64,${btoa(binary)}`;
};

export const getFileExtension = (fileName?: string): string | null => {
  if (!fileName) return null;

  const match = fileName.match(/\.([^.]+)$/);
  return match ? match[1].toLowerCase() : null;
};

export const getFileIconConfig = (
  fileName?: string,
  theme?: DefaultTheme,
): { iconString: IconProps['iconString']; color?: string } => {
  const extension = getFileExtension(fileName);

  if (extension && isFileType(extension)) {
    const config = FILE_ICON_CONFIG[extension];
    return {
      iconString: config.iconString,
      color: theme ? config.color(theme) : undefined,
    };
  }

  return {
    iconString: 'file' satisfies keyof typeof FONT_AWESOME_ICONS,
    color: theme?.color.type.secondary,
  };
};
